import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import api from 'config';


export const getProposalGroup = async (idx) => {
  const { data } = await axios.get(`${api.config.companyAPI}/proposal/v1/${idx}`);
  return data;
};

export const getProposalStore = async (groupIdx, idx) => {
  const { data } = await axios.get(`${api.config.companyAPI}/proposal/v1/${groupIdx}/relations/${idx}`);
  return data;
};

export const approveStores = async (idx, approveData) => {
  const { data } = await axios.put(`${api.config.companyAPI}/proposal/v1/${idx}/approval`, approveData);
  return data;
};
